import { View, Text } from '@react-pdf/renderer'
import { styles } from '../styles'

export function PageFooter({ surveyLevel = 1 }) {
  return (
    <View style={styles.footer} fixed>
      <Text>RICS Home Survey - Level {surveyLevel}</Text>
      <Text render={({ pageNumber, totalPages }) => `Page ${pageNumber} of ${totalPages}`} />
    </View>
  )
}

export default PageFooter
